import { useState, useEffect, useCallback } from 'react';
import ticketApi from '../services/ticketApi';
import {
  LOADING_STATES,
  ERROR_MESSAGES,
  SUCCESS_MESSAGES
} from '../constants';


const useStatusMappings = () => {

  const [mappings, setMappings] = useState([]);

  const [loading, setLoading] = useState(LOADING_STATES.IDLE);
  const [error, setError] = useState(null);

  
  const handleError = useCallback((err, defaultMessage) => {
    console.error('Status Mappings API Error:', err);
    setError(err.message || defaultMessage);
    
  }, []);

  
  const fetchAllMappings = useCallback(async () => {
    setLoading(LOADING_STATES.LOADING);
    setError(null);

    try {
      const result = await ticketApi.getAllStatusMappings();
      setMappings(result);
      setLoading(LOADING_STATES.SUCCESS);
    } catch (err) {
      handleError(err, ERROR_MESSAGES.FETCH_FAILED);
      setLoading(LOADING_STATES.ERROR);
    }
  }, [handleError]);

  
  

    
  const createMapping = useCallback(async (mappingData) => {
    try {
      const result = await ticketApi.createStatusMapping(mappingData);
      
      setMappings(prev => [...prev, result]);
      
    
      
      return { success: true, data: result, message: SUCCESS_MESSAGES.CREATE_SUCCESS };
    } catch (err) {
      const errorMessage = err.message || ERROR_MESSAGES.CREATE_FAILED;
      return { success: false, error: errorMessage };
    }
  }, []);

  
  const updateMapping = useCallback(async (id, mappingData) => {
    try {
      const result = await ticketApi.updateStatusMapping(id, mappingData);
      
      setMappings(prev => prev.map(mapping => 
        mapping.id === id ? result : mapping
      ));
      
      
      
      return { success: true, data: result, message: SUCCESS_MESSAGES.UPDATE_SUCCESS };
    } catch (err) {
      const errorMessage = err.message || ERROR_MESSAGES.UPDATE_FAILED;
      return { success: false, error: errorMessage };
    }
  }, []);

  
  const deleteMapping = useCallback(async (id) => {
    try {
      await ticketApi.deleteStatusMapping(id);
      
      
      setMappings(prev => prev.filter(mapping => mapping.id !== id));
      
      
      
      
      return { success: true, message: SUCCESS_MESSAGES.DELETE_SUCCESS };
    } catch (err) {
      const errorMessage = err.message || ERROR_MESSAGES.DELETE_FAILED;
      return { success: false, error: errorMessage };
    }
  }, []);


  const filterByTicketType = useCallback((ticketType) => {
    // Filter mappings by ticket type - implementation will be handled by parent component
    console.log('Filtering by ticket type:', ticketType);
  }, []);


  const clearFilters = useCallback(() => {
    // Clear filters - implementation will be handled by parent component
  }, []);


  useEffect(() => {
    fetchAllMappings();
  }, [fetchAllMappings]);

  
  

  return {
    mappings,
    loading,
    error,
    isLoading: loading === LOADING_STATES.LOADING,
    createMapping,
    updateMapping,
    deleteMapping,
    filterByTicketType,
    clearFilters,
  };
};

export { useStatusMappings as default };
export { useStatusMappings };
